export const characters = [
  {
    id: "tsuna",
    name: "泽田纲吉",
    en: "Tsunayoshi Sawada",
    faction: "core",
    role: "彭格列十代首领候补",
    flame: "大空",
    title: "从「废柴纲」出发的主角",
    desc: "故事的第一视角。胆小、爱逃避、运动与学习都不擅长，却在被强行推上家族继承之路后，一次次被逼着直面危险。他的成长并非一蹴而就，而是在反复的退缩与坚持之间慢慢积累。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20teenage%20boy%20with%20spiky%20brown%20hair%20and%20nervous%20but%20earnest%20eyes%2C%20wearing%20a%20black%20school%20uniform%2C%20warm%20amber%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-tsuna&orientation=portrait",
  },
  {
    id: "reborn",
    name: "里包恩",
    en: "Reborn",
    faction: "core",
    role: "纲吉的家庭教师 · 世界级杀手",
    flame: "晴",
    title: "全剧最不能惹的小婴儿",
    desc: "外表是穿着西装、戴着礼帽的婴儿，说话冷静又毒舌。他是纲吉的老师，也是整部作品的节奏掌控者，几乎每一次纲吉的突破背后都有他的安排。作为彩虹之子之一，他背负着与常人不同的身份与代价。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20tiny%20baby%20in%20a%20black%20suit%20and%20fedora%20hat%20with%20a%20green%20chameleon%20on%20his%20shoulder%2C%20calm%20sharp%20expression%2C%20warm%20orange%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-reborn&orientation=portrait",
  },
  {
    id: "gokudera",
    name: "狱寺隼人",
    en: "Hayato Gokudera",
    faction: "guardian",
    role: "岚之守护者",
    flame: "岚",
    title: "十代目最忠诚的追随者",
    desc: "性格火爆、对纲吉近乎盲目地忠诚。表面一副不良少年做派，实际上头脑聪明、擅长爆破与战术。他在团队里常是最先冲上去的那个人，也常因为冲动吃亏。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20man%20with%20silver%20grey%20hair%20and%20piercing%20green%20eyes%2C%20wearing%20a%20dark%20jacket%2C%20fierce%20confident%20look%2C%20warm%20amber%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-gokudera&orientation=portrait",
  },
  {
    id: "yamamoto",
    name: "山本武",
    en: "Takeshi Yamamoto",
    faction: "guardian",
    role: "雨之守护者",
    flame: "雨",
    title: "把战斗当棒球的天然系剑士",
    desc: "开朗、直率、运动全能，是把一切都往好的方向理解的乐天派。他最初把黑手党的事当成游戏，后来才逐渐察觉事情的重量，并成长为可靠的剑术战力。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20cheerful%20young%20man%20with%20short%20black%20hair%20and%20a%20bright%20smile%2C%20wearing%20a%20school%20jersey%2C%20friendly%20energetic%20mood%2C%20warm%20orange%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-yamamoto&orientation=portrait",
  },
  {
    id: "lambo",
    name: "蓝波",
    en: "Lambo",
    faction: "guardian",
    role: "雷之守护者",
    flame: "雷",
    title: "爱吃糖的意大利小少爷",
    desc: "来自波维诺家族的五岁小孩，淘气、爱哭、动不动就掏炸弹。靠着十年后火箭筒，他能在幼年与成年状态之间切换，也因此常制造出剧情的意外惊喜与喜剧效果。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20cheerful%20toddler%20boy%20with%20a%20big%20cow%20print%20hairband%20and%20a%20lollipop%2C%20mischievous%20grin%2C%20warm%20amber%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-lambo&orientation=portrait",
  },
  {
    id: "hibari",
    name: "云雀恭弥",
    en: "Kyoya Hibari",
    faction: "guardian",
    role: "云之守护者 · 风纪委员长",
    flame: "云",
    title: "并盛町最强的独狼",
    desc: "讨厌群聚、只认同自己规则的并盛中学风纪委员长。他不受任何组织约束，却因为守护这片街区而成为不可替代的战力。话少、动手快，气场是角色里最强的之一。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20reserved%20young%20man%20with%20short%20black%20hair%20and%20cold%20sharp%20eyes%2C%20wearing%20a%20black%20uniform%20with%20an%20armband%2C%20aloof%20aura%2C%20warm%20amber%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-hibari&orientation=portrait",
  },
  {
    id: "mukuro",
    name: "六道骸",
    en: "Mukuro Rokudo",
    faction: "guardian",
    role: "雾之守护者",
    flame: "雾",
    title: "从宿敌到战友的幻术师",
    desc: "掌握六道能力的幻术使用者，最初以敌人身份登场，后来以独特的方式成为雾之守护者。他的言行始终游走在敌我之间，是作品里最难被简单定义的角色之一。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20mysterious%20young%20man%20with%20long%20teal%20hair%20and%20heterochromic%20red%20and%20blue%20eyes%2C%20elegant%20dark%20coat%2C%20cryptic%20smile%2C%20warm%20amber%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-mukuro&orientation=portrait",
  },
  {
    id: "ryohei",
    name: "笹川了平",
    en: "Ryohei Sasagawa",
    faction: "guardian",
    role: "晴之守护者",
    flame: "晴",
    title: "极限热血的拳击部部长",
    desc: "拳击部主将，口头禅是「极限」。性格直接到近乎憨直，对训练与战斗都投入满格热情。他在队伍里承担着把气氛拉起来、也把同伴护在身后的位置。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20muscular%20young%20man%20with%20a%20short%20crew%20cut%20and%20boxing%20bandages%2C%20energetic%20shouting%20expression%2C%20warm%20orange%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-ryohei&orientation=portrait",
  },
  {
    id: "chrome",
    name: "库洛姆·髑髅",
    en: "Chrome Dokuro",
    faction: "guardian",
    role: "雾之守护者（代理）",
    flame: "雾",
    title: "安静却坚定的幻术伙伴",
    desc: "性格内向、说话轻声的少女，因与六道骸的因果联系而获得幻术能力。她常常被低估，却总在关键时刻站出来，是队伍情感浓度很高的一位成员。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20quiet%20young%20woman%20with%20short%20dark%20purple%20hair%20and%20one%20eye%20covered%20by%20a%20patch%2C%20soft%20gentle%20expression%2C%20warm%20amber%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-chrome&orientation=portrait",
  },
  {
    id: "dino",
    name: "迪诺",
    en: "Dino",
    faction: "ally",
    role: "加百罗涅家族十代首领",
    flame: "大空",
    title: "里包恩的另一位学生",
    desc: "意大利加百罗涅家族的年轻首领，也是里包恩早年的弟子，因此常以师兄弟的身份与纲吉交流。性格可靠、待人温和，是纲吉在家族世界中难得的长辈型伙伴。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20friendly%20blond%20young%20man%20wearing%20a%20long%20coat%2C%20relaxed%20approachable%20smile%2C%20warm%20orange%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-dino&orientation=portrait",
  },
  {
    id: "uni",
    name: "尤尼",
    en: "Uni",
    faction: "ally",
    role: "基耶德罗家族首领 · 彩虹之子",
    flame: "大空",
    title: "背负宿命的少女",
    desc: "外表年幼却承担着家族与彩虹之子双重身份的少女，性格温柔而坚韧。她在剧情后段的作用非常关键，也让彩虹之子这条线索真正收束。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20small%20girl%20with%20long%20blue%20grey%20hair%20and%20a%20gentle%20sad%20smile%2C%20wearing%20a%20white%20dress%2C%20warm%20amber%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-uni&orientation=portrait",
  },
  {
    id: "enma",
    name: "古里炎真",
    en: "Enma Kozato",
    faction: "ally",
    role: "西蒙家族十代首领",
    flame: "地",
    title: "与纲吉极其相似的少年",
    desc: "性格怯懦、一度被孤立，与早期的纲吉几乎如出一辙。作为西蒙家族的首领，他带来的地属性火焰为作品引入了新的力量体系，也让纲吉面对了「像自己一样的人」这一课题。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20shy%20teenage%20boy%20with%20messy%20reddish%20brown%20hair%20and%20glasses%2C%20timid%20but%20sincere%20expression%2C%20warm%20orange%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-enma&orientation=portrait",
  },
  {
    id: "iemitsu",
    name: "泽田家光",
    en: "Iemitsu Sawada",
    faction: "ally",
    role: "彭格列门外顾问",
    flame: "",
    title: "常年缺席的父亲",
    desc: "纲吉的父亲，以海外工程人员为表面身份，实际上是彭格列的核心人物之一。他在纲吉人生的关键节点出现，既是推动者，也是让纲吉对「继承」这件事产生复杂情绪的原因。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20tall%20hearty%20middle%20aged%20man%20with%20short%20brown%20hair%20and%20a%20big%20grin%2C%20wearing%20a%20casual%20jacket%2C%20warm%20amber%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-iemitsu&orientation=portrait",
  },
  {
    id: "nana",
    name: "沢田奈奈",
    en: "Nana Sawada",
    faction: "ally",
    role: "纲吉的母亲",
    flame: "",
    title: "把一切怪事当日常的人",
    desc: "性格天然温柔，对家里不断出现的怪人怪事总能一笑带过。她是纲吉日常生活的锚点，也是作品喜剧节奏的重要来源，让紧绷的战斗线始终有一处松弛的出口。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20warm%20kind%20young%20mother%20with%20short%20brown%20hair%20and%20a%20gentle%20smile%2C%20wearing%20a%20simple%20apron%2C%20cozy%20home%20mood%2C%20warm%20orange%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-nana&orientation=portrait",
  },
  {
    id: "xanxus",
    name: "XANXUS",
    en: "Xanxus",
    faction: "rival",
    role: "瓦利亚部队首领",
    flame: "大空",
    title: "觊觎首领之位的挑战者",
    desc: "彭格列暗杀部队瓦利亚的首领，气场压人、行事狠辣。他自认有资格继承彭格列，因而与纲吉围绕继承权展开正面对决，是作品早期最重要的反派对手。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20tall%20menacing%20man%20with%20dark%20spiky%20hair%20and%20angry%20red%20eyes%20and%20a%20long%20scar%2C%20wearing%20a%20black%20coat%20with%20fur%2C%20intimidating%20aura%2C%20warm%20orange%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-xanxus&orientation=portrait",
  },
  {
    id: "byakuran",
    name: "白兰",
    en: "Byakuran",
    faction: "rival",
    role: "密鲁菲奥雷家族首领",
    flame: "大空",
    title: "未来篇的最终对手",
    desc: "笑容和善、语气轻快，却是未来篇中最大的威胁。他握有横跨平行世界的信息优势，几乎让主角阵营陷入无解的局面，是作品里压迫感最强的敌人之一。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20an%20elegant%20young%20man%20with%20short%20white%20hair%20and%20a%20soft%20dangerous%20smile%2C%20wearing%20a%20white%20military%20style%20coat%2C%20warm%20amber%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-byakuran&orientation=portrait",
  },
  {
    id: "gamma",
    name: "伽马",
    en: "Gamma",
    faction: "rival",
    role: "基耶德罗家族干部",
    flame: "雷",
    title: "立场摇摆的忠诚者",
    desc: "尤尼的部下，态度强硬、执行果断，最初以敌对立场登场。随着剧情推进，他对家族的忠诚与对局势的判断让他成为理解「敌人并非全是恶人」的一个例子。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20serious%20young%20man%20with%20short%20dark%20blue%20hair%20and%20sunglasses%20pushed%20up%2C%20stern%20loyal%20expression%2C%20warm%20orange%20gradient%20background%2C%20clean%20cel%20shaded%20illustration%2C%20no%20text&width=600&height=750&seq=reborn-char-gamma&orientation=portrait",
  },
];

export const factionTabs = [
  { id: "all", label: "全部角色" },
  { id: "core", label: "首领与导师" },
  { id: "guardian", label: "守护者" },
  { id: "ally", label: "同盟阵营" },
  { id: "rival", label: "敌对势力" },
];